import React, { useState, useEffect } from "react";
import moment from "moment";
import momentTz from "moment-timezone";
import "moment/locale/da";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { textTranslate } from "../../utils/i18n";

// Add export module to highChart
require("highcharts/modules/exporting")(Highcharts);
require("highcharts/modules/export-data")(Highcharts);

const CompareChartComp = props => {
  const { seriesesData } = props;
  const [chartConfig, setChartConfig] = useState({
    chart: {
      type: "area",
      zoomType: "x",
      panning: true,
      panKey: "shift",
      reflow: true,
      spacingTop: 30,
      height: props.height ? props.height : 150,
      scrollablePlotArea: {
        // minWidth: 600
      }
    },

    title: {
      text: " "
    },
    subtitle: {
      text: " "
    },

    yAxis: {
      title: {
        text: textTranslate("chartData")
      }
    },

    legend: {
      layout: "horizontal",
      align: "center",
      verticalAlign: "bottom"
    },
    xAxis: {
      type: "datetime",
      tickPixelInterval: 50,

      dateTimeLabelFormats: {
        millisecond: "%H:%M:%S.%L",
        second: "%H:%M:%S",
        minute: "%H:%M",
        hour: "%H:%M",
        day: "%e. %b",
        week: "%e. %b",
        month: "%b '%y",
        year: "%Y"
      }
    },
    series: [
      {
        dataGrouping: {
          enabled: false
        }
      }
    ],
    time: {
      time: "",
      getTimezoneOffset: function (timestamp) {
        var zone = momentTz.tz.guess(),
          timezoneOffset = -moment.tz(timestamp, zone).utcOffset();
        return timezoneOffset;
      }
    },
    lang: {
      loading: "Loading...",
      months: moment.months(),
      weekdays: moment.weekdays(),
      shortMonths: moment.monthsShort()
    }
  });

  useEffect(() => {
    let _newSerises = [];
    seriesesData.forEach(deviceData => {
      let _data_arr = [];
      deviceData.trendsData.forEach(dataReading => {
        _data_arr.push([Date.parse(dataReading.ts), dataReading.v]);
      });
      _newSerises.push({
        name: deviceData.device + " (" + textTranslate("chartData") + ") <br/>" + deviceData.name,
        type: "column",
        data: _data_arr
      });
    });

    setChartConfig({
      ...chartConfig,
      series: [..._newSerises],
      xAxis: {
        type: "datetime",
        dateTimeLabelFormats: getDateFormat()
      },
      tooltip: {
        shared: true,
        crosshairs: [true, true],
        formatter: function () {
          return this.points.reduce(function (s, point) {
            return s + "<br/>" + point.series.name + ": <b> " + point.y + "</b>";
          }, " ");
        }
      }
    });
  }, [seriesesData]);

  function getDateFormat() {
    switch (props.period.value) {
      case "day":
        return {
          hour: "%H:%M"
        };
      case "week":
        return {
          day: "%e. %b"
        };
      case "month":
        return {
          day: "%e. %b"
        };

      default:
        break;
    }
  };

  return (
    <React.Fragment>
      {!!chartConfig && (
        <React.Fragment>
          <HighchartsReact highcharts={Highcharts} options={chartConfig} />
        </React.Fragment>
      )}
    </React.Fragment>
  );
};

export default CompareChartComp;
